module.exports = __webpack_public_path__ + "static/media/cemetery.da2adc54.svg";